export const authActionTypes = {
    LOG_IN_REQUEST: 'LOG_IN_REQUEST',
    LOG_IN_SUCCESS: 'LOG_IN_SUCCESS',
    LOG_IN_FAILURE: 'LOG_IN_FAILURE',
    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILURE: 'REGISTER_FAILURE',
    LOG_OUT_REQUEST: 'LOG_OUT_REQUEST',
    LOG_OUT_SUCCESS: 'LOG_OUT_SUCCESS',
    LOG_OUT_FAILURE: 'LOG_OUT_FAILURE',
};
